export const COLOR_MAPPING = { 1: "red", 2: "green", 3: "yellow", 4: "blue" };
export const BORDER_COLOR_MAPPING = {
  1: "danger",
  2: "success",
  3: "warning",
  4: "primary",
};
